<template>
  <div class="ai_settings">
    <div v-if="loading" class="spinner"><scale-loader /></div>
    <div v-else class="settings_list">
      <AiSettingsItem
          class="models"
          :name="translate('ai_settings.models')"
          :columns="model_columns"
          :rows="models"
      />
      <AiSettingsItem
          :name="translate('ai_settings.tasks')"
          :columns="task_columns"
          :rows="tasks"
      />
      <AiSettingsItem
          :name="translate('ai_settings.assignments')"
          :columns="assignment_columns"
          :rows="assignments"
      />
    </div>
  </div>
</template>

<script>
import AiSettingsItem from './Item/Index.vue'

export default {
  name: 'AiSettings',
  components: {
    AiSettingsItem
  },
  data () {
    return {
      loading: true,
      models: [],
      tasks: [],
      model_columns: ['id', 'name', 'provider', 'model_name', 'base_url', 'is_active', 'timeout', 'use_proxy', 'proxy_url', 'input_per_1m', 'output_per_1m', 'api_key_env', 'api_key_configured'],
      task_columns: ['id', 'code', 'name', 'is_active', 'selected_model_id', 'status'],
      assignment_columns: ['task_id', 'model_id', 'is_active', 'priority']
    }
  },
  computed: {
    assignments() {
      let assignments = []
      this.tasks.forEach(task => {
        (task.assignments || []).forEach(assignment => {
          assignments.push({
            task_id: task.id,
            model_id: assignment.model_id,
            is_active: assignment.is_active,
            priority: assignment.priority
          })
        })
      })
      return assignments
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init() {
      this.$http.v1.getAiRouting((response) => {
        this.models = response.data.models
        this.tasks = response.data.tasks
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ai_settings {
  height: 100%;
  overflow-y: auto;
  padding: 10px 0 0;
  .settings_list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    align-items: start;
    .models {
      grid-column: 1 / -1;
    }
  }
}

@media (max-width: 991px) {
  .ai_settings .settings_list {
    grid-template-columns: minmax(0, 1fr);
  }
}
</style>
